import { render, staticRenderFns } from "./Create-Project.vue?vue&type=template&id=c4713666"
import script from "./Create-Project.vue?vue&type=script&lang=js"
export * from "./Create-Project.vue?vue&type=script&lang=js"
import style0 from "./Create-Project.vue?vue&type=style&index=0&id=c4713666&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports